import { ReactNode } from 'react';

import { CarInfoBaseProps } from './types';
import { CarInfoCardBase } from './CarInfoCard.Base';

type CarInfoCardDesktopProps = {
  base: CarInfoBaseProps;
  infoSlot?: ReactNode;
  bannerSlot?: ReactNode;
  className?: string;
};

export const CarInfoCardDesktop = ({
  base,
  infoSlot,
  bannerSlot,
  className,
}: CarInfoCardDesktopProps) => {
  return (
    <CarInfoCardBase
      base={base}
      infoSlot={infoSlot}
      bannerSlot={bannerSlot}
      className={className}
      layout="row"
    />
  );
};
